export const HIMALAYAS_LIBRARY_INDEX = 0,
  HIMALAYAS_PROJECT_INDEX = 1,
  SPICE_CARD_TEMPLATE_INDEX = 0,
  HIMALAYAS_IO_SIM_INDEX = 1,
  HIMALAYAS_TRASH_INDEX = 2;


export const HIMALAYAS_PROJECT_VERSION = '0.0.1';